module.exports = __webpack_public_path__ + "img/location-1-active.c7248d70.png";